import { render, staticRenderFns } from "./userInfoMobil.vue?vue&type=template&id=0b56d6a2&"
import script from "./userInfoMobil.vue?vue&type=script&lang=ts&"
export * from "./userInfoMobil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports